export default __webpack_public_path__ + "static/media/Ico-scan.a527a7f8.svg";